/*
 * @Author: Liux
 * @Date: 2019-09-26 08:06:00
 * @LastEditor: Liux
 * @LastEditTime: 2021-03-12 06:28:26
 */
import {
  Component,
  OnInit,
  AfterContentInit,
  Input,
  ViewChild,
  ViewContainerRef,
  TemplateRef,
  EventEmitter,
  HostListener,
  ElementRef,
  ChangeDetectionStrategy,
  Renderer2,
  OnDestroy,
  ChangeDetectorRef,
  NgZone,
} from '@angular/core';
import { AdDashboardBoxEventService } from '../ad-dashboard-box-event.service';
import { AdDashboardWidgetEventService } from '../ad-dashboard-widget-event.service';
import { AdDashboardConnectBoxServiceService } from '../ad-dashboard-connect-box-service.service';
import { GridsterItemComponent, GridsterPush } from 'angular-gridster2';

@Component({
  selector: 'ad-dashboard-box',
  templateUrl: './ad-dashboard-box.component.html',
  styleUrls: ['./ad-dashboard-box.component.scss'],
  providers: [
    AdDashboardBoxEventService,
    AdDashboardWidgetEventService,
    AdDashboardConnectBoxServiceService,
  ],
})
export class AdDashboardBoxComponent
  implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild('headerRight', { read: ViewContainerRef, static: false })
  headerRightViewContainerRef: ViewContainerRef;
  @ViewChild('contentWrapper', { read: ElementRef, static: true })
  contentWrapper: ElementRef;

  @ViewChild('containerWrapper', { read: ElementRef, static: true })
  containerWrapper: ElementRef;
  @Input()
  isOpenSetting = false;
  @Input() title = '';
  @Input() subTitle = '';
  @Input() instanceID: number;
  @Input() type = '';
  @Input() setting: Array<{ Name: string; Value: string }> = [];

  @Input() hideCloseBtn = true;
  @Input() hideSettingBtn = true;

  @Input() minRows: number;
  @Input() maxRows: number;
  @Input() rowHeight: number;
  @Input() rowGap = 10;
  @Input() headerHeight = 40;

  @Input() headerRightButtons: AdDashboardBoxButton[] = [];
  headerLeftTemplate: TemplateRef<any>;
  headerRightTemplate: TemplateRef<any>;

  public onButtonClick: EventEmitter<any> = new EventEmitter();
  public onClose: EventEmitter<any> = new EventEmitter();
  public onInit: EventEmitter<any> = new EventEmitter();
  public onSettingBtnClick: EventEmitter<any> = new EventEmitter();

  headerTemplateRef: TemplateRef<any> = undefined;

  mouseDownEventRemover;
  touchStartDownEventRemover;

  @Input()
  tooltip: string;

  constructor(
    private dashboardBoxEventService: AdDashboardBoxEventService,
    private widgetEventService: AdDashboardWidgetEventService,
    private itemToPush: GridsterItemComponent,
    private hostElementRef: ElementRef,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  onMouseDown(e: Event) {
    const clickEvent = document.createEvent('MouseEvents');
    clickEvent.initEvent('mousedown', true, true);
    document.dispatchEvent(clickEvent); // trigger document click event to close other dropdown list popup window.
    this.cd.detectChanges();
    e.stopPropagation();
  }
  ngOnInit() {
    this.widgetEventService.onLoading.subscribe((evnt) => {});
    this.widgetEventService.onResize.subscribe((size) => {
      this.resize(size);
    });
    this.widgetEventService.onSettingChange.subscribe((evnt) => {});
    this.widgetEventService.onRightButtonChange.subscribe((buttons) => {
      this.setRightButtons(buttons);
    });
    this.widgetEventService.onRightHeaderTemplateChange.subscribe((tpl) => {
      this.setRightHeaderTemplate(tpl);
    });
    this.ngZone.runOutsideAngular(() => {
      this.mouseDownEventRemover = this.renderer.listen(
        this.hostElementRef.nativeElement,
        'mousedown',
        (e: Event) => {
          this.onMouseDown(e);
        }
      );
      this.touchStartDownEventRemover = this.renderer.listen(
        this.hostElementRef.nativeElement,
        'touchstart',
        (e: Event) => {
          this.onMouseDown(e);
        }
      );
    });
  }
  ngOnDestroy(): void {
    this.mouseDownEventRemover();
    this.touchStartDownEventRemover();
  }
  autoResize(height: number = 0) {
    if (this.rowHeight > 0) {
      if (height === 0) {
        const rect = this.contentWrapper.nativeElement.firstElementChild.getBoundingClientRect();
        height = rect.height;
      }

      //include the rowGap to calculate the correct row number.
      const rowNumber =
        Math.ceil(height + this.rowGap) / (this.rowHeight + this.rowGap);

      //const rowNumber = Math.ceil(height / this.rowHeight);
      this.resize({
        rows: rowNumber,
        cols: this.itemToPush.item.cols,
      });
    }
  }

  resize(size: AdDashboarxBoxSize) {
    if (this.maxRows > 0 && size.rows > this.maxRows) {
      size.rows = this.maxRows;
    }

    if (this.minRows > 0 && size.rows < this.minRows) {
      size.rows = this.minRows;
    }

    const push = new GridsterPush(this.itemToPush); // init the service
    this.itemToPush.$item.rows = size.rows; // move/resize your item
    if (
      (push as any).gridster !== undefined &&
      push.pushItems(push.fromNorth)
    ) {
      push.checkPushBack(); // check for items can restore to original position
      push.setPushedItems(); // save the items pushed
      this.itemToPush.setSize();
      this.itemToPush.checkItemChanges(
        this.itemToPush.$item,
        this.itemToPush.item
      );
    }
    push.destroy(); // destroy push instance
    // similar for GridsterPushResize and GridsterSwap
  }

  getWidgetHeight() {
    return (
      this.rowHeight * this.itemToPush.item.rows +
      (this.itemToPush.item.rows - 1) * this.rowGap
    );
  }
  getContentHeight() {
    return this.contentWrapper.nativeElement.firstElementChild.getBoundingClientRect()
      .height;
  }

  setRightButtons(buttons: any) {
    this.headerRightButtons = [
      ...buttons.sort((a, b) => {
        if (a.sort > b.sort) {
          return 1;
        } else if (a.sort < b.sort) {
          return -1;
        }
        return 0;
      }),
    ];
    this.dashboardBoxEventService.onButtonChange.emit(this.headerRightButtons);
  }

  setRightHeaderTemplate(tpl: TemplateRef<any>) {
    if (this.headerRightViewContainerRef) {
      this.headerRightViewContainerRef.clear();
      this.headerRightViewContainerRef.createEmbeddedView(tpl);
    }
  }

  setHeaderTemplate(tpl: TemplateRef<any>) {
    this.headerTemplateRef = tpl;
  }

  buttonClick(event, button: AdDashboardBoxButton) {
    const obj = {
      event,
      button,
      code: button.code,
    };
    this.dashboardBoxEventService.onButtonClick.emit(obj);

    this.onButtonClick.emit(obj);
  }

  settingButtonClick(event) {
    this.isOpenSetting = !this.isOpenSetting;
    const obj = {
      event,
      isOpen: this.isOpenSetting,
    };
    this.dashboardBoxEventService.onSettingClick.emit(obj);
    this.onSettingBtnClick.emit(obj);
  }

  closeButtonClick(event) {
    this.dashboardBoxEventService.onRemove.emit({ event });
    this.onClose.emit({ event });
  }

  ngAfterContentInit(): void {
    const obj = {
      instanceID: this.instanceID,
      setting: this.setting,
      title: this.title,
      subTitle: this.subTitle,
      type: this.type,
    };
    this.dashboardBoxEventService.onInit.emit(obj);
    this.onInit.emit(obj);
  }
}

export class AdDashboardBoxButton {
  public text: string;
  public code: string;
  public cssClass: string;
  public iconClass: string;
  public sortIndex: number;
  public disabled: boolean;

  /**
   *
   */
  constructor(
    _text: string,
    _code: string,
    _cssClass: string,
    _iconClass: string,
    _sortIndex: number,
    _disabled: boolean
  ) {
    this.text = _text;
    this.code = _code;
    this.cssClass = _cssClass;
    this.iconClass = _iconClass;
    this.sortIndex = _sortIndex;
    this.disabled = _disabled;
  }
}

export class AdDashboarxBoxSize {
  public rows: number;
  public cols: number;

  /**
   *
   */
  constructor(_rows: number, _cols: number) {
    this.rows = _rows;
    this.cols = _cols;
  }
}
